module.exports = __webpack_public_path__ + "img/mlogo.ceaa8075.png";